import { useQuery } from "react-query";
import { IMonthlyPayment } from "../types";
import { AxiosResponse } from "axios";
import api from "services/client/client";
import useQueryHook from "hooks/useQueryHook";

export const useGetPayments = (selectedYear: string) => {
  const { AddQueryParams, QueryParams } = useQueryHook();

  // QueryParams dagi barcha qiymatlarni queryKey ga qo'shish
  const response = useQuery<Record<string, IMonthlyPayment>>(
    [
      "payments",
      selectedYear,
      QueryParams.statusId,
      QueryParams.month,
    ],
    async () => {
      try {
        const response = await api.get<AxiosResponse<IMonthlyPayment[]>>(
          "payment/academic-year",
          {
            params: {
              page: 1,
              limit: 50,
              academicYearId: selectedYear,
              statusId: QueryParams.statusId,
              month: QueryParams.month,
              classId: QueryParams.classId,
              studentId: QueryParams.studentId,
            },
          }
        );
        const mutatedData: Record<string, IMonthlyPayment> = {};

        response.data.data.forEach(
          (item) => (mutatedData[item.student._id] = item)
        );

        return mutatedData;
        // @ts-ignore
      } catch (error: AxiosResponse<Data>) {
        if (error?.statusCode === 401) {
          window.location.replace("/login");
          return error;
        }

        return {
          data: [],
        };
      }
    },
    {
      enabled: !!selectedYear,
    }
  );

  return response;
};
